import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 350);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          key="scroll-top"
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          transition={{ duration: 0.22, ease: 'easeOut' }}
          onClick={scrollTop}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.93 }}
          className="fixed bottom-6 left-6 z-[8900] w-11 h-11 rounded-full bg-[var(--color-deep)] border border-white/10 shadow-xl flex items-center justify-center text-white hover:bg-[var(--color-brand)] transition-colors"
          aria-label="Torna in cima"
          data-testid="scroll-to-top-btn"
        >
          <ArrowUp size={18} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
